var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvertImage2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 573.259,
    height: 595.546,
    viewBox: "0 0 573.259 595.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_3910",
    x: 145.934,
    y: 322.324,
    width: 420,
    height: 108,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#176b41",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14562",
    "data-name": "Group 14562",
    transform: "translate(-227.066 -4984.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14243",
    "data-name": "Group 14243",
    transform: "translate(199.411 4984.676) rotate(90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2957",
    "data-name": "Ellipse 2957",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3198",
    "data-name": "Ellipse 3198",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2958",
    "data-name": "Ellipse 2958",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2959",
    "data-name": "Ellipse 2959",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3200",
    "data-name": "Ellipse 3200",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2960",
    "data-name": "Ellipse 2960",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2833",
    "data-name": "Ellipse 2833",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3088",
    "data-name": "Ellipse 3088",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2834",
    "data-name": "Ellipse 2834",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2835",
    "data-name": "Ellipse 2835",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3090",
    "data-name": "Ellipse 3090",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2836",
    "data-name": "Ellipse 2836",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2961",
    "data-name": "Ellipse 2961",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3202",
    "data-name": "Ellipse 3202",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2962",
    "data-name": "Ellipse 2962",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2963",
    "data-name": "Ellipse 2963",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3204",
    "data-name": "Ellipse 3204",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2964",
    "data-name": "Ellipse 2964",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2837",
    "data-name": "Ellipse 2837",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3092",
    "data-name": "Ellipse 3092",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2838",
    "data-name": "Ellipse 2838",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2839",
    "data-name": "Ellipse 2839",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3094",
    "data-name": "Ellipse 3094",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2840",
    "data-name": "Ellipse 2840",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2965",
    "data-name": "Ellipse 2965",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3206",
    "data-name": "Ellipse 3206",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2966",
    "data-name": "Ellipse 2966",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2967",
    "data-name": "Ellipse 2967",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3208",
    "data-name": "Ellipse 3208",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2968",
    "data-name": "Ellipse 2968",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2841",
    "data-name": "Ellipse 2841",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3096",
    "data-name": "Ellipse 3096",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2842",
    "data-name": "Ellipse 2842",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2843",
    "data-name": "Ellipse 2843",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3098",
    "data-name": "Ellipse 3098",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2844",
    "data-name": "Ellipse 2844",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2969",
    "data-name": "Ellipse 2969",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2970",
    "data-name": "Ellipse 2970",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2845",
    "data-name": "Ellipse 2845",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2846",
    "data-name": "Ellipse 2846",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2971",
    "data-name": "Ellipse 2971",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2972",
    "data-name": "Ellipse 2972",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2847",
    "data-name": "Ellipse 2847",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2848",
    "data-name": "Ellipse 2848",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2973",
    "data-name": "Ellipse 2973",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3214",
    "data-name": "Ellipse 3214",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2974",
    "data-name": "Ellipse 2974",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2975",
    "data-name": "Ellipse 2975",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3216",
    "data-name": "Ellipse 3216",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2976",
    "data-name": "Ellipse 2976",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2849",
    "data-name": "Ellipse 2849",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3104",
    "data-name": "Ellipse 3104",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2850",
    "data-name": "Ellipse 2850",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2851",
    "data-name": "Ellipse 2851",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3105",
    "data-name": "Ellipse 3105",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2852",
    "data-name": "Ellipse 2852",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2977",
    "data-name": "Ellipse 2977",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3218",
    "data-name": "Ellipse 3218",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2978",
    "data-name": "Ellipse 2978",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2979",
    "data-name": "Ellipse 2979",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3220",
    "data-name": "Ellipse 3220",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2980",
    "data-name": "Ellipse 2980",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2853",
    "data-name": "Ellipse 2853",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3107",
    "data-name": "Ellipse 3107",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2854",
    "data-name": "Ellipse 2854",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2855",
    "data-name": "Ellipse 2855",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3108",
    "data-name": "Ellipse 3108",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2856",
    "data-name": "Ellipse 2856",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2981",
    "data-name": "Ellipse 2981",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3222",
    "data-name": "Ellipse 3222",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2982",
    "data-name": "Ellipse 2982",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2983",
    "data-name": "Ellipse 2983",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3224",
    "data-name": "Ellipse 3224",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2984",
    "data-name": "Ellipse 2984",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2857",
    "data-name": "Ellipse 2857",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3110",
    "data-name": "Ellipse 3110",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2858",
    "data-name": "Ellipse 2858",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2859",
    "data-name": "Ellipse 2859",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3111",
    "data-name": "Ellipse 3111",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2860",
    "data-name": "Ellipse 2860",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2985",
    "data-name": "Ellipse 2985",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2986",
    "data-name": "Ellipse 2986",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2861",
    "data-name": "Ellipse 2861",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2862",
    "data-name": "Ellipse 2862",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2987",
    "data-name": "Ellipse 2987",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2988",
    "data-name": "Ellipse 2988",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2863",
    "data-name": "Ellipse 2863",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2864",
    "data-name": "Ellipse 2864",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2925",
    "data-name": "Ellipse 2925",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3114",
    "data-name": "Ellipse 3114",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2926",
    "data-name": "Ellipse 2926",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2927",
    "data-name": "Ellipse 2927",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3116",
    "data-name": "Ellipse 3116",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2928",
    "data-name": "Ellipse 2928",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2929",
    "data-name": "Ellipse 2929",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3121",
    "data-name": "Ellipse 3121",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2930",
    "data-name": "Ellipse 2930",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2931",
    "data-name": "Ellipse 2931",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3123",
    "data-name": "Ellipse 3123",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2932",
    "data-name": "Ellipse 2932",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2933",
    "data-name": "Ellipse 2933",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3128",
    "data-name": "Ellipse 3128",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2934",
    "data-name": "Ellipse 2934",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2935",
    "data-name": "Ellipse 2935",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3130",
    "data-name": "Ellipse 3130",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2936",
    "data-name": "Ellipse 2936",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2937",
    "data-name": "Ellipse 2937",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2938",
    "data-name": "Ellipse 2938",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2939",
    "data-name": "Ellipse 2939",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2940",
    "data-name": "Ellipse 2940",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2941",
    "data-name": "Ellipse 2941",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3140",
    "data-name": "Ellipse 3140",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2942",
    "data-name": "Ellipse 2942",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2943",
    "data-name": "Ellipse 2943",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3142",
    "data-name": "Ellipse 3142",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2944",
    "data-name": "Ellipse 2944",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2946",
    "data-name": "Ellipse 2946",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2947",
    "data-name": "Ellipse 2947",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3149",
    "data-name": "Ellipse 3149",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2948",
    "data-name": "Ellipse 2948",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2949",
    "data-name": "Ellipse 2949",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3154",
    "data-name": "Ellipse 3154",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2950",
    "data-name": "Ellipse 2950",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2951",
    "data-name": "Ellipse 2951",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3156",
    "data-name": "Ellipse 3156",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2952",
    "data-name": "Ellipse 2952",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2953",
    "data-name": "Ellipse 2953",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2954",
    "data-name": "Ellipse 2954",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2955",
    "data-name": "Ellipse 2955",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2956",
    "data-name": "Ellipse 2956",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2879",
    "data-name": "Ellipse 2879",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3166",
    "data-name": "Ellipse 3166",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2880",
    "data-name": "Ellipse 2880",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2881",
    "data-name": "Ellipse 2881",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3168",
    "data-name": "Ellipse 3168",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2882",
    "data-name": "Ellipse 2882",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2885",
    "data-name": "Ellipse 2885",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3170",
    "data-name": "Ellipse 3170",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2886",
    "data-name": "Ellipse 2886",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2887",
    "data-name": "Ellipse 2887",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3172",
    "data-name": "Ellipse 3172",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2888",
    "data-name": "Ellipse 2888",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2891",
    "data-name": "Ellipse 2891",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3174",
    "data-name": "Ellipse 3174",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2892",
    "data-name": "Ellipse 2892",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2893",
    "data-name": "Ellipse 2893",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3176",
    "data-name": "Ellipse 3176",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2894",
    "data-name": "Ellipse 2894",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2897",
    "data-name": "Ellipse 2897",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2898",
    "data-name": "Ellipse 2898",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2900",
    "data-name": "Ellipse 2900",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2901",
    "data-name": "Ellipse 2901",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2902",
    "data-name": "Ellipse 2902",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3182",
    "data-name": "Ellipse 3182",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2903",
    "data-name": "Ellipse 2903",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2904",
    "data-name": "Ellipse 2904",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3184",
    "data-name": "Ellipse 3184",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2905",
    "data-name": "Ellipse 2905",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2989",
    "data-name": "Ellipse 2989",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3230",
    "data-name": "Ellipse 3230",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2990",
    "data-name": "Ellipse 2990",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2991",
    "data-name": "Ellipse 2991",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3232",
    "data-name": "Ellipse 3232",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2992",
    "data-name": "Ellipse 2992",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2908",
    "data-name": "Ellipse 2908",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3186",
    "data-name": "Ellipse 3186",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2909",
    "data-name": "Ellipse 2909",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2910",
    "data-name": "Ellipse 2910",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3188",
    "data-name": "Ellipse 3188",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2911",
    "data-name": "Ellipse 2911",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2993",
    "data-name": "Ellipse 2993",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3234",
    "data-name": "Ellipse 3234",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2994",
    "data-name": "Ellipse 2994",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2995",
    "data-name": "Ellipse 2995",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3236",
    "data-name": "Ellipse 3236",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2996",
    "data-name": "Ellipse 2996",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2914",
    "data-name": "Ellipse 2914",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3190",
    "data-name": "Ellipse 3190",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2915",
    "data-name": "Ellipse 2915",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2916",
    "data-name": "Ellipse 2916",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3192",
    "data-name": "Ellipse 3192",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2917",
    "data-name": "Ellipse 2917",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2997",
    "data-name": "Ellipse 2997",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3238",
    "data-name": "Ellipse 3238",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2998",
    "data-name": "Ellipse 2998",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2999",
    "data-name": "Ellipse 2999",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3240",
    "data-name": "Ellipse 3240",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3000",
    "data-name": "Ellipse 3000",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2920",
    "data-name": "Ellipse 2920",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2921",
    "data-name": "Ellipse 2921",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3001",
    "data-name": "Ellipse 3001",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3002",
    "data-name": "Ellipse 3002",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2923",
    "data-name": "Ellipse 2923",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2924",
    "data-name": "Ellipse 2924",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3003",
    "data-name": "Ellipse 3003",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3004",
    "data-name": "Ellipse 3004",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14244",
    "data-name": "Group 14244",
    transform: "translate(682.411 5362.676) rotate(90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2957-2",
    "data-name": "Ellipse 2957",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3198-2",
    "data-name": "Ellipse 3198",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2958-2",
    "data-name": "Ellipse 2958",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2959-2",
    "data-name": "Ellipse 2959",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3200-2",
    "data-name": "Ellipse 3200",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2960-2",
    "data-name": "Ellipse 2960",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2833-2",
    "data-name": "Ellipse 2833",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3088-2",
    "data-name": "Ellipse 3088",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2834-2",
    "data-name": "Ellipse 2834",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2835-2",
    "data-name": "Ellipse 2835",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3090-2",
    "data-name": "Ellipse 3090",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2836-2",
    "data-name": "Ellipse 2836",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2961-2",
    "data-name": "Ellipse 2961",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3202-2",
    "data-name": "Ellipse 3202",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2962-2",
    "data-name": "Ellipse 2962",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2963-2",
    "data-name": "Ellipse 2963",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3204-2",
    "data-name": "Ellipse 3204",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2964-2",
    "data-name": "Ellipse 2964",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2837-2",
    "data-name": "Ellipse 2837",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3092-2",
    "data-name": "Ellipse 3092",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2838-2",
    "data-name": "Ellipse 2838",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2839-2",
    "data-name": "Ellipse 2839",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3094-2",
    "data-name": "Ellipse 3094",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2840-2",
    "data-name": "Ellipse 2840",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2965-2",
    "data-name": "Ellipse 2965",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3206-2",
    "data-name": "Ellipse 3206",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2966-2",
    "data-name": "Ellipse 2966",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2967-2",
    "data-name": "Ellipse 2967",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3208-2",
    "data-name": "Ellipse 3208",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2968-2",
    "data-name": "Ellipse 2968",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2841-2",
    "data-name": "Ellipse 2841",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3096-2",
    "data-name": "Ellipse 3096",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2842-2",
    "data-name": "Ellipse 2842",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2843-2",
    "data-name": "Ellipse 2843",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3098-2",
    "data-name": "Ellipse 3098",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2844-2",
    "data-name": "Ellipse 2844",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2969-2",
    "data-name": "Ellipse 2969",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2970-2",
    "data-name": "Ellipse 2970",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2845-2",
    "data-name": "Ellipse 2845",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2846-2",
    "data-name": "Ellipse 2846",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2971-2",
    "data-name": "Ellipse 2971",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2972-2",
    "data-name": "Ellipse 2972",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2847-2",
    "data-name": "Ellipse 2847",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2848-2",
    "data-name": "Ellipse 2848",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2973-2",
    "data-name": "Ellipse 2973",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3214-2",
    "data-name": "Ellipse 3214",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2974-2",
    "data-name": "Ellipse 2974",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2975-2",
    "data-name": "Ellipse 2975",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3216-2",
    "data-name": "Ellipse 3216",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2976-2",
    "data-name": "Ellipse 2976",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2849-2",
    "data-name": "Ellipse 2849",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3104-2",
    "data-name": "Ellipse 3104",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2850-2",
    "data-name": "Ellipse 2850",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2851-2",
    "data-name": "Ellipse 2851",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3105-2",
    "data-name": "Ellipse 3105",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2852-2",
    "data-name": "Ellipse 2852",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2977-2",
    "data-name": "Ellipse 2977",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3218-2",
    "data-name": "Ellipse 3218",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2978-2",
    "data-name": "Ellipse 2978",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2979-2",
    "data-name": "Ellipse 2979",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3220-2",
    "data-name": "Ellipse 3220",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2980-2",
    "data-name": "Ellipse 2980",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2853-2",
    "data-name": "Ellipse 2853",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3107-2",
    "data-name": "Ellipse 3107",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2854-2",
    "data-name": "Ellipse 2854",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2855-2",
    "data-name": "Ellipse 2855",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3108-2",
    "data-name": "Ellipse 3108",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2856-2",
    "data-name": "Ellipse 2856",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2981-2",
    "data-name": "Ellipse 2981",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3222-2",
    "data-name": "Ellipse 3222",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2982-2",
    "data-name": "Ellipse 2982",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2983-2",
    "data-name": "Ellipse 2983",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3224-2",
    "data-name": "Ellipse 3224",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2984-2",
    "data-name": "Ellipse 2984",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2857-2",
    "data-name": "Ellipse 2857",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3110-2",
    "data-name": "Ellipse 3110",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2858-2",
    "data-name": "Ellipse 2858",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2859-2",
    "data-name": "Ellipse 2859",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3111-2",
    "data-name": "Ellipse 3111",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2860-2",
    "data-name": "Ellipse 2860",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2985-2",
    "data-name": "Ellipse 2985",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2986-2",
    "data-name": "Ellipse 2986",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2861-2",
    "data-name": "Ellipse 2861",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2862-2",
    "data-name": "Ellipse 2862",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2987-2",
    "data-name": "Ellipse 2987",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2988-2",
    "data-name": "Ellipse 2988",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2863-2",
    "data-name": "Ellipse 2863",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2864-2",
    "data-name": "Ellipse 2864",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2925-2",
    "data-name": "Ellipse 2925",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3114-2",
    "data-name": "Ellipse 3114",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2926-2",
    "data-name": "Ellipse 2926",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2927-2",
    "data-name": "Ellipse 2927",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3116-2",
    "data-name": "Ellipse 3116",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2928-2",
    "data-name": "Ellipse 2928",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2929-2",
    "data-name": "Ellipse 2929",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3121-2",
    "data-name": "Ellipse 3121",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2930-2",
    "data-name": "Ellipse 2930",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2931-2",
    "data-name": "Ellipse 2931",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3123-2",
    "data-name": "Ellipse 3123",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2932-2",
    "data-name": "Ellipse 2932",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2933-2",
    "data-name": "Ellipse 2933",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3128-2",
    "data-name": "Ellipse 3128",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2934-2",
    "data-name": "Ellipse 2934",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2935-2",
    "data-name": "Ellipse 2935",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3130-2",
    "data-name": "Ellipse 3130",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2936-2",
    "data-name": "Ellipse 2936",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2937-2",
    "data-name": "Ellipse 2937",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2938-2",
    "data-name": "Ellipse 2938",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2939-2",
    "data-name": "Ellipse 2939",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2940-2",
    "data-name": "Ellipse 2940",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2941-2",
    "data-name": "Ellipse 2941",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3140-2",
    "data-name": "Ellipse 3140",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2942-2",
    "data-name": "Ellipse 2942",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2943-2",
    "data-name": "Ellipse 2943",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3142-2",
    "data-name": "Ellipse 3142",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2944-2",
    "data-name": "Ellipse 2944",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2946-2",
    "data-name": "Ellipse 2946",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2947-2",
    "data-name": "Ellipse 2947",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3149-2",
    "data-name": "Ellipse 3149",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2948-2",
    "data-name": "Ellipse 2948",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2949-2",
    "data-name": "Ellipse 2949",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3154-2",
    "data-name": "Ellipse 3154",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2950-2",
    "data-name": "Ellipse 2950",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2951-2",
    "data-name": "Ellipse 2951",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3156-2",
    "data-name": "Ellipse 3156",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2952-2",
    "data-name": "Ellipse 2952",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2953-2",
    "data-name": "Ellipse 2953",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2954-2",
    "data-name": "Ellipse 2954",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2955-2",
    "data-name": "Ellipse 2955",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2956-2",
    "data-name": "Ellipse 2956",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2879-2",
    "data-name": "Ellipse 2879",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3166-2",
    "data-name": "Ellipse 3166",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2880-2",
    "data-name": "Ellipse 2880",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2881-2",
    "data-name": "Ellipse 2881",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3168-2",
    "data-name": "Ellipse 3168",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2882-2",
    "data-name": "Ellipse 2882",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2885-2",
    "data-name": "Ellipse 2885",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3249",
    "data-name": "Ellipse 3249",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3170-2",
    "data-name": "Ellipse 3170",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3472",
    "data-name": "Ellipse 3472",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -75.548)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2886-2",
    "data-name": "Ellipse 2886",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2887-2",
    "data-name": "Ellipse 2887",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3172-2",
    "data-name": "Ellipse 3172",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2888-2",
    "data-name": "Ellipse 2888",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2891-2",
    "data-name": "Ellipse 2891",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3174-2",
    "data-name": "Ellipse 3174",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2892-2",
    "data-name": "Ellipse 2892",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2893-2",
    "data-name": "Ellipse 2893",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3176-2",
    "data-name": "Ellipse 3176",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2894-2",
    "data-name": "Ellipse 2894",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2897-2",
    "data-name": "Ellipse 2897",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2898-2",
    "data-name": "Ellipse 2898",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2900-2",
    "data-name": "Ellipse 2900",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2901-2",
    "data-name": "Ellipse 2901",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2902-2",
    "data-name": "Ellipse 2902",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3182-2",
    "data-name": "Ellipse 3182",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2903-2",
    "data-name": "Ellipse 2903",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2904-2",
    "data-name": "Ellipse 2904",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3184-2",
    "data-name": "Ellipse 3184",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2905-2",
    "data-name": "Ellipse 2905",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2989-2",
    "data-name": "Ellipse 2989",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3230-2",
    "data-name": "Ellipse 3230",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2990-2",
    "data-name": "Ellipse 2990",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2991-2",
    "data-name": "Ellipse 2991",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3232-2",
    "data-name": "Ellipse 3232",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2992-2",
    "data-name": "Ellipse 2992",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2908-2",
    "data-name": "Ellipse 2908",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3186-2",
    "data-name": "Ellipse 3186",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2909-2",
    "data-name": "Ellipse 2909",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2910-2",
    "data-name": "Ellipse 2910",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3188-2",
    "data-name": "Ellipse 3188",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2911-2",
    "data-name": "Ellipse 2911",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2993-2",
    "data-name": "Ellipse 2993",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3234-2",
    "data-name": "Ellipse 3234",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2994-2",
    "data-name": "Ellipse 2994",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2995-2",
    "data-name": "Ellipse 2995",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3236-2",
    "data-name": "Ellipse 3236",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2996-2",
    "data-name": "Ellipse 2996",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2914-2",
    "data-name": "Ellipse 2914",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3190-2",
    "data-name": "Ellipse 3190",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2915-2",
    "data-name": "Ellipse 2915",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2916-2",
    "data-name": "Ellipse 2916",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3192-2",
    "data-name": "Ellipse 3192",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2917-2",
    "data-name": "Ellipse 2917",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2997-2",
    "data-name": "Ellipse 2997",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3238-2",
    "data-name": "Ellipse 3238",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2998-2",
    "data-name": "Ellipse 2998",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2999-2",
    "data-name": "Ellipse 2999",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3240-2",
    "data-name": "Ellipse 3240",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3000-2",
    "data-name": "Ellipse 3000",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2920-2",
    "data-name": "Ellipse 2920",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2921-2",
    "data-name": "Ellipse 2921",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3001-2",
    "data-name": "Ellipse 3001",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3002-2",
    "data-name": "Ellipse 3002",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2923-2",
    "data-name": "Ellipse 2923",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2924-2",
    "data-name": "Ellipse 2924",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3003-2",
    "data-name": "Ellipse 3003",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3004-2",
    "data-name": "Ellipse 3004",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3902",
    "data-name": "Rectangle 3902",
    transform: "translate(268 5026)",
    fill: "#fff",
    stroke: "#d7dfe6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 492,
    height: 500,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 491,
    height: 499,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Conversion_details",
    "data-name": "Conversion details",
    transform: "translate(328 5076)",
    fill: "#111",
    fontSize: 24,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700,
    letterSpacing: "-0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Conversion details")), /*#__PURE__*/React.createElement("g", {
    id: "Group_14234",
    "data-name": "Group 14234",
    transform: "translate(-372 4896)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1.00_USD_81.013_INR",
    "data-name": "1.00 USD = 81.013 INR",
    transform: "translate(754 380)",
    fill: "#111",
    fontSize: 15,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1.00 USD = 81.013 INR")), /*#__PURE__*/React.createElement("text", {
    id: "Today_at_01:14_PM",
    "data-name": "Today at 01:14 PM",
    transform: "translate(754 402)",
    fill: "#848b9c",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Today at 01:14 PM")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M11.414,12.989l3.951,3.825a.762.762,0,0,0,1.055,0,.712.712,0,0,0,0-1.023l-4.477-4.333a.764.764,0,0,0-1.03-.021L6.405,15.787a.71.71,0,0,0,0,1.023.762.762,0,0,0,1.055,0Z",
    transform: "translate(916.813 360.754)",
    fill: "#242784"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Exchange_rate",
    "data-name": "Exchange rate",
    transform: "translate(754 350)",
    fill: "#176b41",
    fontSize: 16,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Exchange rate"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14235",
    "data-name": "Group 14235",
    transform: "translate(-625 4897)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "To",
    transform: "translate(1007 537)",
    fill: "#176b41",
    fontSize: 18,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "To")), /*#__PURE__*/React.createElement("text", {
    id: "_80_455.00_INR",
    "data-name": "80,455.00 INR",
    transform: "translate(1007 565)",
    fill: "#111",
    fontSize: 20,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "80,455.00 INR")), /*#__PURE__*/React.createElement("text", {
    id: "Available:_45_000.00",
    "data-name": "Available: \\u20B945,000.00",
    transform: "translate(1007 592)",
    fill: "#848b9c",
    fontSize: 13,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Available: "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, "\u20B945,000.00")), /*#__PURE__*/React.createElement("g", {
    id: "_055-india",
    "data-name": "055-india",
    transform: "translate(1158.63 549)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2512",
    "data-name": "Rectangle 2512",
    width: 25.37,
    height: 17.304,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2513",
    "data-name": "Rectangle 2513",
    width: 25.37,
    height: 6.678,
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2514",
    "data-name": "Rectangle 2514",
    width: 25.37,
    height: 6.678,
    transform: "translate(0 10.627)",
    fill: "#6da544"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 2.576,
    cy: 2.576,
    r: 2.576,
    transform: "translate(10.109 6.076)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1.61,
    cy: 1.61,
    r: 1.61,
    transform: "translate(11.075 7.042)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M228.4,222.146l.5,1.127,1.224-.133-.727.993.727.993-1.224-.133-.5,1.127-.5-1.127-1.224.133.727-.993-.727-.993,1.224.133Z",
    transform: "translate(-215.717 -215.481)",
    fill: "#0052b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14236",
    "data-name": "Group 14236",
    transform: "translate(-625 4893)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Convert",
    transform: "translate(1007 257)",
    fill: "#176b41",
    fontSize: 18,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Convert")), /*#__PURE__*/React.createElement("text", {
    id: "_1_000.00_USD",
    "data-name": "1,000.00 USD",
    transform: "translate(1007 285)",
    fill: "#111",
    fontSize: 20,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1,000.00 USD")), /*#__PURE__*/React.createElement("text", {
    id: "Available:_21_600.76",
    "data-name": "Available: $21,600.76",
    transform: "translate(1007 312)",
    fill: "#848b9c",
    fontSize: 13,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Available:"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    xmlSpace: "preserve",
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, " $21,600.76")), /*#__PURE__*/React.createElement("g", {
    id: "_185-united_states_of_america",
    "data-name": "185-united states of america",
    transform: "translate(1141.154 268.531)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2500",
    "data-name": "Rectangle 2500",
    width: 25.69,
    height: 17.938,
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7436",
    "data-name": "Group 7436",
    transform: "translate(0 2.287)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2501",
    "data-name": "Rectangle 2501",
    width: 25.69,
    height: 2.287,
    transform: "translate(0 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2502",
    "data-name": "Rectangle 2502",
    width: 25.69,
    height: 2.287,
    transform: "translate(0 3.693)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 25.69,
    height: 2.287,
    transform: "translate(0 7.385)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2504",
    "data-name": "Rectangle 2504",
    width: 25.69,
    height: 2.287,
    transform: "translate(0 11.077)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2505",
    "data-name": "Rectangle 2505",
    width: 14.789,
    height: 10.618,
    transform: "translate(0 0)",
    fill: "#2e52b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7437",
    "data-name": "Group 7437",
    transform: "translate(1.502 1.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M83.372,160.624l-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-79.107 -157.98)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M83.609,207.13l-.238-.733-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453Z",
    transform: "translate(-79.107 -201.108)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M27.247,207.13l-.238-.733-.238.733H26l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453Z",
    transform: "translate(-26.001 -201.108)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M27.01,160.624l-.238.733H26l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-26.001 -157.98)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M83.372,114.85l-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-79.107 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M27.01,114.85l-.238.733H26l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-26.001 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M139.734,160.624l-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-132.213 -157.98)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M139.971,207.13l-.238-.733-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453Z",
    transform: "translate(-132.213 -201.108)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M196.334,207.13l-.238-.733-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453Z",
    transform: "translate(-185.32 -201.108)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M196.1,160.624l-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-185.32 -157.98)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M139.734,114.85l-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-132.213 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M196.1,114.85l-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-185.32 -114.85)",
    fill: "#f0f0f0"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "Getting_a_new_quote_in_15_seconds...",
    "data-name": "Getting a new quote in 15 seconds...",
    transform: "translate(328 5108)",
    fill: "#5d6578",
    fontSize: 13,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Getting a new quote in "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#111",
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, "15 "), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "seconds...")), /*#__PURE__*/React.createElement("g", {
    id: "Group_14233",
    "data-name": "Group 14233",
    transform: "translate(-510 4428.055)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2541",
    "data-name": "Rectangle 2541",
    width: 1,
    height: 283,
    transform: "translate(854 721.945)",
    fill: "#d7dfe6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3246",
    "data-name": "Ellipse 3246",
    transform: "translate(328 5133)",
    fill: "#fff",
    stroke: "#cdd8e1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3247",
    "data-name": "Ellipse 3247",
    transform: "translate(328 5229)",
    fill: "#fff",
    stroke: "#cdd8e1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14239",
    "data-name": "Group 14239",
    transform: "translate(217.301 5219.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-swap-horiz",
    "data-name": "Icon material-swap-horiz",
    d: "M8.738,14.4,4.5,18.649,8.738,22.9V19.711h7.445V17.587H8.738Z",
    transform: "translate(113.199 10.292)",
    fill: "#61ce65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-swap-horiz-2",
    "data-name": "Icon material-swap-horiz",
    d: "M24.233,11.748,20,7.5v3.186H12.551V12.81H20V16Z",
    transform: "translate(111.659 11.743)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_076-wallet",
    "data-name": "076-wallet",
    transform: "translate(330 5135.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color",
    transform: "translate(9.721 7.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8110",
    "data-name": "Group 8110",
    transform: "translate(8.321 7.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M27.439,21.391H24.821a1.571,1.571,0,1,1,0-3.141h2.618Z",
    transform: "translate(-23.25 -18.25)",
    fill: "#61ce65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8112",
    "data-name": "Group 8112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M17.732,7.75,15.986,8.8,11.33,11.59h8.643Z",
    transform: "translate(-11.33 -7.75)",
    fill: "#61ce65"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "line",
    transform: "translate(6 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8119",
    "data-name": "Group 8119",
    transform: "translate(0 1.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M7.047,10.42H6A1.922,1.922,0,0,1,7.92,8.5h6.458V9.547H7.92A.874.874,0,0,0,7.047,10.42Z",
    transform: "translate(-6 -8.5)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8120",
    "data-name": "Group 8120",
    transform: "translate(0 2.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M20.137,23.292H7.92A1.921,1.921,0,0,1,6,21.373V11.25H7.047V21.373a.873.873,0,0,0,.873.873H20.137a.176.176,0,0,0,.175-.175V19.278h1.047v2.792A1.223,1.223,0,0,1,20.137,23.292Z",
    transform: "translate(-6 -11.25)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8121",
    "data-name": "Group 8121",
    transform: "translate(11.519 7.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M27.212,21.689H24.594a2.094,2.094,0,1,1,0-4.189h2.618a.524.524,0,0,1,.524.524v3.141A.524.524,0,0,1,27.212,21.689Zm-2.618-3.141a1.047,1.047,0,0,0,0,2.094h2.094V18.547Z",
    transform: "translate(-22.5 -17.5)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8122",
    "data-name": "Group 8122",
    transform: "translate(10.737 1.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M23.907,11.816H22.86V9.722a.176.176,0,0,0-.175-.175H21.38V8.5h1.305a1.223,1.223,0,0,1,1.222,1.222Z",
    transform: "translate(-21.38 -8.5)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8123",
    "data-name": "Group 8123",
    transform: "translate(3.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M11.483,11.812l-.538-.9,6.4-3.84a.523.523,0,0,1,.721.186l2.241,3.84-.9.528L17.431,8.246Z",
    transform: "translate(-10.945 -7)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8124",
    "data-name": "Group 8124",
    transform: "translate(0 2.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M21.358,16.137H20.311V13.344a.176.176,0,0,0-.175-.175H7.92A1.931,1.931,0,0,1,6,11.25H7.047a.882.882,0,0,0,.873.873H20.137a1.223,1.223,0,0,1,1.222,1.222Z",
    transform: "translate(-6 -11.25)",
    fill: "#176b41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3248",
    "data-name": "Ellipse 3248",
    transform: "translate(328 5417)",
    fill: "#fff",
    stroke: "#cdd8e1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_076-wallet-2",
    "data-name": "076-wallet",
    transform: "translate(330 5419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color-2",
    "data-name": "color",
    transform: "translate(9.721 7.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8110-2",
    "data-name": "Group 8110",
    transform: "translate(8.321 7.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1201-2",
    "data-name": "Path 1201",
    d: "M27.439,21.391H24.821a1.571,1.571,0,1,1,0-3.141h2.618Z",
    transform: "translate(-23.25 -18.25)",
    fill: "#61ce65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8112-2",
    "data-name": "Group 8112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1203-2",
    "data-name": "Path 1203",
    d: "M17.732,7.75,15.986,8.8,11.33,11.59h8.643Z",
    transform: "translate(-11.33 -7.75)",
    fill: "#61ce65"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "line-2",
    "data-name": "line",
    transform: "translate(6 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8119-2",
    "data-name": "Group 8119",
    transform: "translate(0 1.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1209-2",
    "data-name": "Path 1209",
    d: "M7.047,10.42H6A1.922,1.922,0,0,1,7.92,8.5h6.458V9.547H7.92A.874.874,0,0,0,7.047,10.42Z",
    transform: "translate(-6 -8.5)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8120-2",
    "data-name": "Group 8120",
    transform: "translate(0 2.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1210-2",
    "data-name": "Path 1210",
    d: "M20.137,23.292H7.92A1.921,1.921,0,0,1,6,21.373V11.25H7.047V21.373a.873.873,0,0,0,.873.873H20.137a.176.176,0,0,0,.175-.175V19.278h1.047v2.792A1.223,1.223,0,0,1,20.137,23.292Z",
    transform: "translate(-6 -11.25)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8121-2",
    "data-name": "Group 8121",
    transform: "translate(11.519 7.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1211-2",
    "data-name": "Path 1211",
    d: "M27.212,21.689H24.594a2.094,2.094,0,1,1,0-4.189h2.618a.524.524,0,0,1,.524.524v3.141A.524.524,0,0,1,27.212,21.689Zm-2.618-3.141a1.047,1.047,0,0,0,0,2.094h2.094V18.547Z",
    transform: "translate(-22.5 -17.5)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8122-2",
    "data-name": "Group 8122",
    transform: "translate(10.737 1.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1212-2",
    "data-name": "Path 1212",
    d: "M23.907,11.816H22.86V9.722a.176.176,0,0,0-.175-.175H21.38V8.5h1.305a1.223,1.223,0,0,1,1.222,1.222Z",
    transform: "translate(-21.38 -8.5)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8123-2",
    "data-name": "Group 8123",
    transform: "translate(3.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1213-2",
    "data-name": "Path 1213",
    d: "M11.483,11.812l-.538-.9,6.4-3.84a.523.523,0,0,1,.721.186l2.241,3.84-.9.528L17.431,8.246Z",
    transform: "translate(-10.945 -7)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8124-2",
    "data-name": "Group 8124",
    transform: "translate(0 2.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1214-2",
    "data-name": "Path 1214",
    d: "M21.358,16.137H20.311V13.344a.176.176,0,0,0-.175-.175H7.92A1.931,1.931,0,0,1,6,11.25H7.047a.882.882,0,0,0,.873.873H20.137a1.223,1.223,0,0,1,1.222,1.222Z",
    transform: "translate(-6 -11.25)",
    fill: "#176b41"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 227.07, 4984.68)",
    filter: "url(#Rectangle_3910)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3910-2",
    "data-name": "Rectangle 3910",
    transform: "translate(154.93 328.32)",
    fill: "#fff",
    stroke: "#d7dfe6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 402,
    height: 90,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 401,
    height: 89,
    rx: 5.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14265",
    "data-name": "Group 14265",
    transform: "translate(395 5333)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "FX_markup",
    "data-name": "FX markup",
    transform: "translate(27.958 19)",
    fill: "#176b41",
    fontSize: 18,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FX markup")), /*#__PURE__*/React.createElement("text", {
    id: "_0.3_",
    "data-name": "0.3%",
    transform: "translate(27.958 45.993)",
    fill: "gray",
    fontSize: 18,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0.3%")), /*#__PURE__*/React.createElement("g", {
    id: "Group_13741",
    "data-name": "Group 13741",
    transform: "translate(9 3.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dollar-send-circle",
    d: "M13.893,24.217a1.159,1.159,0,0,0,1.159-1.159V22.44a4.043,4.043,0,0,0,.4-7.926L12.966,13.9a1.73,1.73,0,0,1-.953-.626,1.7,1.7,0,0,1-.36-1.058,1.735,1.735,0,0,1,1.734-1.729h1.082a1.738,1.738,0,0,1,1.724,1.545,1.159,1.159,0,1,0,2.3-.258,4.043,4.043,0,0,0-3.442-3.554V7.608a1.159,1.159,0,1,0-2.318,0v.618a4.045,4.045,0,0,0-.331,7.917l2.484.618a1.735,1.735,0,0,1-.42,3.418H13.386a1.738,1.738,0,0,1-1.724-1.545,1.159,1.159,0,1,0-2.3.258,4.046,4.046,0,0,0,3.374,3.549v.618a1.159,1.159,0,0,0,1.159,1.159Z",
    transform: "translate(-9.339 -6.449)",
    fill: "#176b41"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14266",
    "data-name": "Group 14266",
    transform: "translate(560.666 5333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7776",
    "data-name": "Group 7776",
    transform: "translate(28.181 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Interbank_rate",
    "data-name": "Interbank rate",
    transform: "translate(0 19)",
    fill: "#176b41",
    fontSize: 18,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Interbank rate")), /*#__PURE__*/React.createElement("text", {
    id: "_1_USD_81.256_INR",
    "data-name": "1 USD = 81.256 INR",
    transform: "translate(0 45.993)",
    fill: "gray",
    fontSize: 18,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1 USD = 81.256 INR")), /*#__PURE__*/React.createElement("g", {
    id: "Group_7626",
    "data-name": "Group 7626",
    transform: "translate(142.926 4.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-information-circle-outline",
    "data-name": "Icon ionic-md-information-circle-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M12.425,5.2A7.219,7.219,0,1,1,7.317,7.317,7.192,7.192,0,0,1,12.425,5.2m0-1.827a9.05,9.05,0,1,0,9.05,9.05,9.048,9.048,0,0,0-9.05-9.05Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#848b9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M18.351,19.737H16.523V14.3h1.827Zm0-7.222H16.523V10.687h1.827Z",
    transform: "translate(-8.387 -6.163)",
    fill: "#848b9c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1 8.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M6.27,18.8a1.02,1.02,0,0,1-.721-1.741l5.44-5.44a1.02,1.02,0,0,1,1.287-.128l3.378,2.256L21.87,7.542a1.02,1.02,0,0,1,1.442,1.442l-6.8,6.8a1.021,1.021,0,0,1-1.287.128l-3.378-2.256L6.991,18.5a1.012,1.012,0,0,1-.721.3Z",
    transform: "translate(-5.251 -7.243)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M19.35,13.37a1.02,1.02,0,0,1-1.02-1.02V9.29H15.27a1.02,1.02,0,1,1,0-2.04h4.08a1.02,1.02,0,0,1,1.02,1.02v4.08A1.02,1.02,0,0,1,19.35,13.37Z",
    transform: "translate(-2.01 -7.25)",
    fill: "#176b41"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertImage2);
export default __webpack_public_path__ + "static/media/convert-image-2.cdf61d9aac20cd1a2b075cb84adf4be4.svg";
export { ForwardRef as ReactComponent };